<template>
  <div>
    <embed-api-table
      title="Keyword Search Result Screenshots"
      module="Search-Results"
      v-bind:refresh-for-id="refreshId"
      default-sort="createdAt DESC"
      @click="resultClicked"
      @itemUpdated="onSearchResultUpdated"
      v-bind:columns="screenshotColumns"
      v-bind:fields="screenshotFields"
      v-bind:filter="screenshotFilter">
    </embed-api-table>
    
    <alert-dlg dlg-id="modal-highlight-alert" title="Confirm Rehighlight" v-bind:messages="alertDlgMessages" v-bind:buttons="alertButtons" @selected="onAlertSelected"></alert-dlg>
    <preview-image dlg-id="screenshot-preview" v-bind:image-blob="previewBlob"></preview-image>
  </div>
</template>

<script>
  import AlertDlg from "./AlertDlg.vue";
  import EmbedApiTable from "./EmbedApiTable.vue";
  import PreviewImage from "./PreviewImage.vue";
  import WebLLCRESTApi from "../api/api.js";
  import { countries } from "../util/geotargets.js";
  import $ from "jquery";
  
  import imgYes from "../assets/plus.svg";
  import imgNo from "../assets/minus.svg";
  
  export default {
    created() {
      // prepare api
      this.api = new WebLLCRESTApi("Search-Results", this.$router);
    },
    
    props: {
      clientId: String,
      canSave: Boolean
    },
    
    data() {
      return {
        screenshotColumns: this.getColumns(),
        
        screenshotFields: { linkData: false },
        screenshotFilter: { clientId: this.clientId, status: "complete" },
        
        refreshId: Date.now().toString(),
        
        alertDlgMessages: [],
        alertButtons: [
          {
            name: "cancel",
            text: "Cancel"
          },
          {
            name: "ok",
            text: "OK"
          }
        ],
        
        rehighlightIds: null,
        previewBlob: null
      };
    },
    
    methods: {
      async resultClicked(data) {
        if(data.item) {
          const result = data.item.item;
          
          if(data.col.text == "Screenshot") {
            // download the image from the api
            const res = await this.api.remoteMethod(result.id + "/image");
            this.previewBlob = await res.blob();
            
            // open our preview dialog
            $('#screenshot-preview').modal('toggle');
          }
          else if(data.col.text == "Rehighlight") {
            // confirm this was planned
            this.alertDlgMessages = [ "Are you sure you want to rehighlight? This may take some time depending on server load, the screenshots should reappear within 1-2 hours." ];
            this.rehighlightIds = [ result.id ];
            
            $("#modal-highlight-alert").modal("show");
          }
        }
        else {
          // bulk rehighlighting
          if(data.col.text == "Rehighlight") {
            // confirm this was planned
            this.alertDlgMessages = [ "Are you sure you want to rehighlight? This may take some time depending on server load, the screenshots should reappear within 1-2 hours." ];
            this.rehighlightIds = data.items.map((entry) => entry.item.id);
            
            $("#modal-highlight-alert").modal("show");
          }
        }
      },
      
      async onAlertSelected(button) {
        if(button == "ok") {
          for(const rehighlightId of this.rehighlightIds) {
            // reset this image back to needing an image
            await this.api.remoteMethod(rehighlightId + "/rehighlight");
          }
          
          // refresh the table
          this.refreshId = Date.now().toString();
        }
      },
      
      async onSearchResultUpdated(data) {
        if(data.col.key == "showInReport") {
          await this.api.updateData(data.item.item.id, {
            showInReport: data.newValue.toString() == "true"
          });
        }
      },
      
      getColumns() {
        const cols = [
          { key: "bulkevent", "text": "Rehighlight", type: "BulkEvent" },
          { key: "keyword", "text": "Keyword", type: "String", sort: true },
          { key: "searchType", "text": "Search Type", type: "String", sort: true },
          { key: "page", "text": "Page", type: "String", sort: true },
          { key: "showGMB", "text": "Show GMB", type: "Boolean", sort: false },
          { key: "locationId", "text": "Location", type: "String", sort: false, fnAsyncLoad: this.resolveLocationId },
          { key: "createdAt", "text": "Search Date", type: "DateTime", sort: true },
          {
            key: "showInReport",
            text: "Show In Report",
            type: "ImageOptions",
            options: [
              { key: true, value: "Yes", img: imgYes, class: "green-option" },
              { key: false, value: "No", img: imgNo, class: "red-option" }
            ],
            editable: true
          },
          { key: "rehighlight", "text": "Rehighlight Links", type: "Event", sort: false, fnAsyncLoad: (item) => (item.captureType == "MangoolsV3" || item.captureType == "manualImageV2" ? "Rehighlight" : null) },
          { key: "screenshot", "text": "Screenshot", type: "Event", sort: false },
        ];
        
        if(this.canSave) {
          cols.unshift({ key: "bulkdelete", "text": "", type: "BulkDelete" });
          cols.push({ key: "delete", "text": "Delete", type: "Delete", sort: false });
        }
        
        return cols;
      },
      
      resolveLocationId(item) {
        for(const country of countries) {
          if(country.id == item.locationId) {
            return country.code;
          }
          
          for(const state of country.states) {
            if(state.id == item.locationId) {
              return state.state;
            }
            
            for(const city of state.cities) {
              if(city.id == item.locationId) {
                return city.city;
              }
            }
          }
        }
        
        return "Unknown (" + item.locationId + ")";
      }
    },
    
    watch: {
      canSave(to, from) {
        this.screenshotColumns = this.getColumns();
      }
    },

    components: {
      AlertDlg,
      EmbedApiTable,
      PreviewImage
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SearchResultTable.vue